export default "__VITE_ASSET__lH4kCNiG__"